import ModularScreen from './containers/modularScreen'

export {default as ModularScreenLayout} from './components/modularScreenLayout'

export default ModularScreen
